import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withRouter } from 'react-router-dom';
import {
    Container,
    Button,
    Col,
    Row,
    Input,
    Label,
    Card,
    CardBody,
} from "reactstrap";
import Select from "react-select";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import {
    getCompanies as onGetCompanies,
    getPeriods as onGetPeriods,
    getTemplateBeginningBalance as onGetTemplateBeginningBalance,
    submitBeginningBalance as onSubmitBeginningBalance
} from "../../store/actions";


import { useSelector, useDispatch } from "react-redux";
import PulseLoader from "react-spinners/PulseLoader";

const ImportBeginningBalance = (props) => {

    //meta title
    document.title = "Import | Beginning Balance | Des Counts";
    const [fileUpload, setFileUpload] = useState(null)

    const { companies, loadingCompany, periods, loadingPeriod, loadingTemplate, loadingSubmit } = useSelector(state => ({
        companies: state.Company.companies,
        loadingCompany: state.Company.loading,
        periods: state.Period.periods,
        loadingPeriod: state.Period.loading,
        loadingTemplate: state.Period.loadingTemplate,
        loadingSubmit: state.Period.loadingSubmit,
    }));

    const [selectedCompany, setSelectedCompany] = useState(null);
    const [optionCompany, setOptionCompany] = useState([]);
    function handleSelectCompany(e) {
        setSelectedCompany(e)
    }

    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [optionPeriod, setOptionPeriod] = useState([]);
    function handleSelectPeriod(e) {
        setSelectedPeriod(e)
    }

    const dispatch = useDispatch();

    function downloadTemplate() {
        if (selectedCompany) {
            dispatch(onGetTemplateBeginningBalance({
                companyId: selectedCompany.value
            }))
        }
    }

    const uploadSubmit = () => {
        if (selectedCompany && fileUpload) {
            const data = new FormData()
            data.append('files', fileUpload)
            dispatch(onSubmitBeginningBalance(data, selectedCompany.value, selectedPeriod.value, props.history))
        }
    }

    useEffect(() => {
        dispatch(onGetCompanies({}))
    }, [dispatch])

    useEffect(() => {
        if (companies) {
            setOptionCompany(companies.map((item) => {
                return { label: item.name, value: item.id.toString() }
            }))
        }
    }, [companies])

    useEffect(() => {
        if (periods) {
            setOptionPeriod(periods.map((item) => {
                return { label: item.name, value: item.id.toString() }
            }))
        }
    }, [periods])

    useEffect(() => {
        if(!loadingSubmit){
            setSelectedCompany(null)
            setSelectedPeriod(null)
            setFileUpload(null)
        }
    }, [loadingSubmit])

    useEffect(() => {
        if (selectedCompany) {
            dispatch(onGetPeriods({ companyId: selectedCompany.value, isOpen: false}))
        }
    }, [selectedCompany])

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Breadcrumbs title="Beginning Balance" breadcrumbItem={"Import Beginning Balance"} />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody style={loadingTemplate || loadingSubmit ? { pointerEvents: "none" } : {}}>
                                    {
                                        !loadingTemplate && !loadingSubmit &&
                                        <>
                                            <div className="d-flex">
                                                <div className="flex-grow-1  mx-1">
                                                    <Label>Company</Label>
                                                    <Select
                                                        value={selectedCompany}
                                                        onChange={handleSelectCompany}
                                                        options={optionCompany}
                                                        isLoading={loadingCompany}
                                                        className="select2-selection"
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                                <div className="flex-grow-1  mx-1">
                                                    <Label>Period</Label>
                                                    <Select
                                                        value={selectedPeriod}
                                                        onChange={handleSelectPeriod}
                                                        options={optionPeriod}
                                                        isLoading={loadingPeriod}
                                                        className="select2-selection"
                                                        isClearable={true}
                                                        menuPosition="fixed"
                                                    />
                                                </div>
                                                <div className="align-self-end mx-1">
                                                    <Button color="primary" className="align-self-botttom mx-1" disabled={!selectedCompany} onClick={downloadTemplate}>
                                                        Download Template
                                                    </Button>
                                                </div>
                                            </div>
                                            <Row className="mt-3">
                                                <Col sm={12}>
                                                    <Label htmlFor="formFile" className="form-label">File Excel</Label>
                                                    <Input className="form-control" type="file" onChange={(e) => {
                                                        if (e.target.files.length > 0) {
                                                            setFileUpload(e.target.files[0])
                                                        }
                                                        else {
                                                            setFileUpload(null)
                                                        }
                                                    }} />
                                                </Col>
                                            </Row>
                                            <Row className="mt-3">
                                                <Col sm={12}>
                                                    <Button color="secondary" className="float-end"
                                                        disabled={loadingTemplate || loadingSubmit} onClick={() => {
                                                            props.history.push("/asset")
                                                        }}>
                                                        Cancel
                                                    </Button>
                                                    <Button color="success" className="me-2 float-end"
                                                        disabled={!fileUpload || !selectedCompany || !selectedPeriod} onClick={uploadSubmit}>
                                                        Submit
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </>
                                    }
                                    {
                                        loadingTemplate &&
                                        <div className="d-flex justify-content-center my-5">
                                            <PulseLoader loading={loadingTemplate} color={'#FFF'} size={12} className="align-self-center" />
                                        </div>
                                    }
                                    {
                                        loadingSubmit &&
                                        <div className="d-flex justify-content-center my-5">
                                            <PulseLoader loading={loadingSubmit} color={'#FFF'} size={12} className="align-self-center" />
                                        </div>
                                    }
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

ImportBeginningBalance.propTypes = {
    history: PropTypes.object,
};

export default withRouter(ImportBeginningBalance)
